import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { UtilsService } from "@core/services/utils";
import { vGlobal } from "@core/types/cb-global-vars";
import { environment } from "environments/environment";
import { ApiService } from "@core/services/api/public-api";
import { map, catchError, finalize } from "rxjs/operators";
import { ErrorDialogService } from "@core/components/error-dialog/errordialog.service";
import { BankProgressBarService } from "@core/components/progress-bar/progress-bar.service";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  @BlockUI() blockUI!: NgBlockUI;

  constructor(
    private _api: ApiService,
    private _utilS: UtilsService,
    private _mStorage: manageStorageService,
    public errorDialogService: ErrorDialogService,
    private _bankProgressBarService: BankProgressBarService,
  ) { }

  private _getTokenActive(): string {
    return this._mStorage.getPropertie("s_accsTkn")
      || this._mStorage.getPropertie("s_fAccsTkn")
      || this._mStorage.getPropertie("s_cRlsTkn")
      || "";
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const wsName: string = request.url.split("/").pop() || '';
    const tokenActive = this._getTokenActive();

    let hBearer = `Bearer ${tokenActive}`,
      hBasic = `Basic ${environment.keyGeoApp}`,
      wsNOLoader = vGlobal.wsNoBlockUI.includes(wsName),
      rqstValid = (request.method === "POST" || request.method === "PUT"),
      isBasic = vGlobal.wsBasic.includes(wsName);

    if (!wsNOLoader && rqstValid) { this._bankProgressBarService.show(); this.blockUI.start(); }
    if (tokenActive && !isBasic) { request = request.clone({ headers: request.headers.set("Authorization", hBearer) }); }
    if (isBasic && environment.production) {
      request = request.clone({ headers: request.headers.set("Authorization", hBasic) });
      request = request.clone({ headers: request.headers.set("Content-Type", "application/json") });
    }
    if (wsName == 'session') { request = request.clone({ headers: request.headers.set("x-sid", this._mStorage.getPropertie('s_xsid') || '') }); }

    // Bypass del Service Worker para peticiones API (evita peticiones duplicadas)
    request = request.clone({ headers: request.headers.set('ngsw-bypass', 'true') });

    request = request.clone({ withCredentials: true, reportProgress: true })
    return next.handle(request).pipe(

      finalize(() => {
        if (!wsNOLoader && rqstValid) { this._bankProgressBarService.hide(); this.blockUI.stop(); }
      }),
      map((response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {

          if (wsName == 'init') {
            let xsidHeader = response.headers.get('x-sid');
            this._mStorage.setItmStorage('s_xsid', xsidHeader)
          }
        }

        return response;
      }),
      catchError((error: HttpErrorResponse) => {
      
        let errorDataBody = error.error?.data,
          dataError = {
            message:
              (error && error.error)
                ? this._utilS.firstMayus(error.error?.mensajeError?.trim() || errorDataBody?.mensajeError?.trim()) || errorDataBody?.errorRules
                : "Ocurrió un error, por favor intenta nuevamente",
            codeError: error.status,
            wsName: wsName,
            codeFiable: (errorDataBody?.numeroError) ? errorDataBody?.numeroError :
              (errorDataBody?.error) ? errorDataBody?.error :
                (errorDataBody?.codigo) ? errorDataBody?.codigo :
                  (errorDataBody?.mensajeError) ? errorDataBody?.mensajeError : 'núm. error desconocido'

          };

        const isNoAlert = vGlobal.wsNoAlert.includes(wsName);
        if (!isNoAlert || error.status === 419) {
          this.errorDialogService.openModalErr(dataError);
        } else if (isNoAlert && error.status === 401) { this._api.logOut(); }

        return throwError(() => dataError);

      })
    );
  }
}
